import { createUnorderedHorizontalList } from '@vfde-brix/ws10/unordered-horizontal-list';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { mountComponent } from '../util/mount';

/**
 * Create Brix Unordered Horizontal List component.
 *
 * @param id - Wrapper ID of the element.
 * @returns Unordered Horizontal List
 * component or null if the element with the given ID is not found.
 */
export const mountHorizontalList = (id: HtmlId) =>
    mountComponent(id, createUnorderedHorizontalList, NO_PATTERN_BUSINESS_LOGIC);
